// ----------------------------
// DOM Element References
// ----------------------------
const openModalBtn = document.getElementById("openModalBtn");
const uploaderModal = document.getElementById("uploaderModal");
const uploaderClose = document.getElementById("uploaderClose");
const dropZone = document.getElementById("dropZone");
const fileInput = document.getElementById("fileInput");
const previewContainer = document.getElementById("previewContainer");
const saveBtn = document.getElementById("saveBtn");
const pdfLinkContainer = document.getElementById("pdfLinkContainer");

// Loader container
const loader = document.createElement("div");
loader.className = "loader";
// loader.innerHTML = "Uploading...";
loader.style.display = "none"; // Initially hidden
pdfLinkContainer.appendChild(loader);
const cropModal = document.getElementById("cropModal");
const cropClose = document.getElementById("cropClose");
const cropImage = document.getElementById("cropImage");
const cropDoneBtn = document.getElementById("cropDoneBtn");

const zoomInBtn = document.getElementById("zoomInBtn");
const zoomOutBtn = document.getElementById("zoomOutBtn");

// Master array of images
let imagesData = [];
let currentEditIndex = null;

// For dragging and resizing
let currentScale = 1;
let isDragging = false;
let isResizing = false;
let resizeDirection = null;
let startWidth, startHeight;
let startX, startY;
let imgStartLeft, imgStartTop;

// ----------------------------
// Modal Open/Close
// ----------------------------
openModalBtn.addEventListener("click", () => {
  uploaderModal.style.display = "block";
});

uploaderClose.addEventListener("click", () => {
  uploaderModal.style.display = "none";
});

cropClose.addEventListener("click", () => {
  cropModal.style.display = "none";
});

// ----------------------------
// File Upload + Preview
// ----------------------------
// Drop zone click => manually open file dialog
dropZone.addEventListener("click", () => {
  if (!fileInput.disabled) {
    fileInput.click();
  }
});

// Prevent the fileInput’s own click from re-triggering
fileInput.addEventListener("click", (e) => {
  e.stopPropagation();
});
dropZone.addEventListener("dragover", (e) => {
  e.preventDefault();
  dropZone.classList.add("active");
});

dropZone.addEventListener("dragleave", () => {
  dropZone.classList.remove("active");
});

dropZone.addEventListener("drop", (e) => {
  e.preventDefault();
  dropZone.classList.remove("active");
  handleFiles(e.dataTransfer.files);
});

fileInput.addEventListener("change", (e) => {
  handleFiles(e.target.files);
  fileInput.value = ""; // Reset for next time
});

function handleFiles(files) {
  const filesArray = Array.from(files);

  // Prevent exceeding 20
  if (imagesData.length + filesArray.length > 20) {
    alert("You can upload a maximum of 20 images.");
    return;
  }

  const promises = filesArray.map((file) => {
    if (!file.type.startsWith("image/")) return Promise.resolve(null);

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.readAsDataURL(file);
    });
  });

  // Once all read, add them
  Promise.all(promises).then((results) => {
    results
      .filter((r) => r !== null)
      .forEach((dataURL) => {
        addImagePreview(dataURL);
      });
  });
}

function addImagePreview(dataURL) {
  const index = imagesData.length;
  imagesData.push({
    dataURL,
    cropData: null,
    position: { x: 0, y: 0 },
    scale: 1,
    processed: false,
  });

  // Build the DOM preview
  const previewDiv = document.createElement("div");
  previewDiv.classList.add("preview");
  previewDiv.setAttribute("data-index", index);

  const img = document.createElement("img");
  img.src = dataURL;
  previewDiv.appendChild(img);

  // Buttons container
  const buttonContainer = document.createElement("div");
  buttonContainer.classList.add("preview-buttons");

  // Edit button
  const editBtn = document.createElement("button");
  editBtn.textContent = "Edit";
  editBtn.classList.add("edit-btn");
  editBtn.addEventListener("click", () => openCropModal(index));
  buttonContainer.appendChild(editBtn);

  // Remove button (✕)
  const removeBtn = document.createElement("button");
  removeBtn.textContent = "✕";
  removeBtn.classList.add("remove-btn");
  removeBtn.addEventListener("click", () => removeImage(index));
  buttonContainer.appendChild(removeBtn);

  previewDiv.appendChild(buttonContainer);
  previewContainer.appendChild(previewDiv);

  updateUploadStatus();
}

// Remove image from array + DOM
function removeImage(index) {
  imagesData.splice(index, 1);

  // Remove preview
  const previewDiv = previewContainer.querySelector(`[data-index="${index}"]`);
  if (previewDiv) previewDiv.remove();

  // Re-label the data-index for subsequent items
  const previews = previewContainer.querySelectorAll(".preview");
  for (let i = index; i < previews.length; i++) {
    const oldIndex = parseInt(previews[i].getAttribute("data-index"), 10);
    previews[i].setAttribute("data-index", oldIndex - 1);
  }

  updateUploadStatus();
}

function updateUploadStatus() {
  if (imagesData.length === 20) {
    fileInput.disabled = true;
    dropZone.classList.add("disabled");
    dropZone.innerHTML = "Maximum 20 images reached";
    saveBtn.disabled = false;
  } else {
    fileInput.disabled = false;
    dropZone.classList.remove("disabled");
    dropZone.innerHTML = `
        Drag & Drop images here or click to browse<br>
        (${imagesData.length}/20 images)
      `;
    saveBtn.disabled = imagesData.length === 0;
  }
  // *** Key line: Disable 'Save' unless exactly 20 images ***
  // saveBtn.disabled = imagesData.length !== 20;
  // saveBtn.style.opacity = imagesData.length !== 20 ? "0.5" : "1";
  // saveBtn.style.cursor = imagesData.length !== 20 ? "not-allowed" : "pointer";
  saveBtn.disabled = false;
saveBtn.style.opacity = "1";
saveBtn.style.cursor = "pointer";
}

// ----------------------------
// Crop/Resize Modal
// ----------------------------
function openCropModal(index) {
  currentEditIndex = index;
  const imageObj = imagesData[index];

  // Restore scale and image state
  currentScale = imageObj.scale || 1;
  cropImage.src = imageObj.dataURL;
  cropImage.style.left = imageObj.position.x + "px";
  cropImage.style.top = imageObj.position.y + "px";
  cropImage.style.transformOrigin = "center";
  cropImage.style.transform = `scale(${currentScale})`;

  // Show modal
  cropModal.style.display = "block";

  // Initialize dragging (resizing was removed for simplicity)
  initCropDrag();
}

function initCropDrag() {
  cropImage.onmousedown = function (e) {
    // If resizing, do not start drag
    if (isResizing) return;
    isDragging = true;
    startX = e.clientX;
    startY = e.clientY;
    imgStartLeft = parseInt(cropImage.style.left, 10) || 0;
    imgStartTop = parseInt(cropImage.style.top, 10) || 0;
    e.preventDefault();
  };
}

document.addEventListener("mousemove", (e) => {
  if (isResizing) {
    // Resizing logic removed for brevity
    return;
  }

  if (!isDragging) return;

  // Dragging
  let dx = e.clientX - startX;
  let dy = e.clientY - startY;
  cropImage.style.left = imgStartLeft + dx + "px";
  cropImage.style.top = imgStartTop + dy + "px";
});

document.addEventListener("mouseup", () => {
  isDragging = false;
  isResizing = false;
  document.querySelector(".crop-box")?.classList.remove("resizing");
});

// Zoom Buttons
// zoomInBtn.addEventListener("click", () => {
//   currentScale += 0.1;
//   cropImage.style.transform = `scale(${currentScale})`;
// });

// zoomOutBtn.addEventListener("click", () => {
//   if (currentScale > 0.2) {
//     currentScale -= 0.1;
//     cropImage.style.transform = `scale(${currentScale})`;
//   }
// });

// Find the slider
const zoomSlider = document.getElementById("zoomSlider");

// Listen for changes on the slider
zoomSlider.addEventListener("input", (e) => {
  currentScale = parseFloat(e.target.value);
  cropImage.style.transform = `scale(${currentScale})`;
});

// Mouse wheel zoom inside crop modal
cropModal.addEventListener("wheel", (e) => {
  if (cropModal.contains(cropImage)) {
    e.preventDefault();
    if (e.deltaY < 0) {
      // Zoom in
      currentScale += 0.05;
    } else {
      // Zoom out
      if (currentScale > 0.2) currentScale -= 0.05;
    }
    // Update both the image scale AND the slider value
    cropImage.style.transform = `scale(${currentScale})`;
    zoomSlider.value = currentScale;
  }
});

// Save changes from crop modal
cropDoneBtn.addEventListener("click", () => {
  const cropBox = document.querySelector(".crop-box");
  const cropRect = cropBox.getBoundingClientRect();
  const imgRect = cropImage.getBoundingClientRect();
  const idx = currentEditIndex;

  // Save the final position/scale
  imagesData[idx].position = {
    x: parseInt(cropImage.style.left, 10) || 0,
    y: parseInt(cropImage.style.top, 10) || 0,
  };
  imagesData[idx].scale = currentScale;

  // Create a canvas matching the cropBox for a simple "cropped" image
  const canvas = document.createElement("canvas");
  canvas.width = cropRect.width;
  canvas.height = cropRect.height;
  const ctx = canvas.getContext("2d");

  // Fill white background
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // Draw from the original
  const tempImg = new Image();
  tempImg.onload = function () {
    const centerX = imgRect.width / 2;
    const centerY = imgRect.height / 2;

    const sourceX =
      (cropRect.left - imgRect.left) / currentScale +
      (tempImg.width / 2 - centerX / currentScale);
    const sourceY =
      (cropRect.top - imgRect.top) / currentScale +
      (tempImg.height / 2 - centerY / currentScale);
    const sourceW = cropRect.width / currentScale;
    const sourceH = cropRect.height / currentScale;

    ctx.drawImage(
      tempImg,
      sourceX,
      sourceY,
      sourceW,
      sourceH,
      0,
      0,
      canvas.width,
      canvas.height
    );

    const croppedDataURL = canvas.toDataURL("image/jpeg", 1.0);
    imagesData[idx].dataURL = croppedDataURL;
    imagesData[idx].processed = true;

    updatePreviewImage(idx, croppedDataURL);
    cropModal.style.display = "none";
  };
  tempImg.src = imagesData[idx].dataURL;
});

function updatePreviewImage(index, newDataURL) {
  const previewDiv = previewContainer.querySelector(`[data-index="${index}"]`);
  if (previewDiv) {
    const img = previewDiv.querySelector("img");
    if (img) img.src = newDataURL;
  }
}

// ----------------------------
// Saving as PDF (then upload)
// ----------------------------
// saveBtn.addEventListener("click", async () => {
//   if (imagesData.length === 0) {
//     alert("Please upload at least one image before saving.");
//     return;
//   }
saveBtn.addEventListener("click", async () => {
  //const addToCartBtn = document.querySelector('button[name="add"]');
  
  // 🟢 If no images uploaded, allow direct Add to Cart
  // if (imagesData.length === 0) {
  //   if (addToCartBtn) {
  //     addToCartBtn.disabled = false;
  //     addToCartBtn.style.opacity = "1";
  //     addToCartBtn.style.cursor = "pointer";
  //   } 
  //   uploaderModal.style.display = "none";
  //   return; // skip upload logic
  // }

  // Disable button and show loader
  saveBtn.disabled = true;
  loader.style.display = "block";
  saveBtn.innerText = "Uploading...";

  // Automatically crop/center any unprocessed images
  const processPromises = imagesData.map((imgData, i) => {
    if (!imgData.processed) {
      return processImageAutomatically(i);
    }
    return Promise.resolve();
  });

  try {
    await Promise.all(processPromises);

    // Small delay so the UI can update
    setTimeout(async () => {
      try {
        // 1) Generate PDF Blob
        const pdfBlob = await generatePDF();

        // 2) Build FormData
        const formData = new FormData();
        formData.append("file", pdfBlob, "images.pdf");

        // 3) Upload to your API
        const response = await fetch(
          "https://bambird-file-upload-api.vercel.app/api/file-upload",
          {
            method: "POST",
            body: formData,
          }
        );

        // 4) Handle the response
        if (!response.ok) {
          throw new Error(`Upload failed with status ${response.status}`);
        }

        const data = await response.json();
        // pdfLinkContainer.innerHTML = "Upload successful!";

        // Extract `id` from response
        const fileId = data?.file?.id;
        if (fileId) {
          const numericId = fileId.split('/').pop(); 
          fileUrl = `https://admin.shopify.com/store/f3b67f/content/files/${numericId}?start=MQ%3D%3D&query=${fileId}`;

          // Add ID to the URL search params
          const url = new URL(window.location.href);
          url.searchParams.set("fileId", fileId);
          url.searchParams.set("fileUrl", fileUrl);
          window.history.replaceState(null, "", url.toString());
          // Immediately enable the Add to Cart button
          const addToCartBtn = document.querySelector('button[name="add"]');
          // Grab the hidden input field for fileId
          const fileIdInput = document.getElementById("fileIdInput");
          const fileUrlInput = document.getElementById("fileUrlInput");
          if (fileIdInput) {
            fileIdInput.value = fileId;
            fileUrlInput.value = fileUrl;
          }

          // // *** Success message ***
          // pdfLinkContainer.innerHTML =
          //   "Upload successful! File ID saved in URL.";

          // Disable 'Save & Upload' button now
          saveBtn.disabled = true;
          saveBtn.innerText = "Uploaded ✔";
          saveBtn.style.opacity = "0.5";
          saveBtn.style.cursor = "not-allowed";

          // If using a separate container for success messages
          const successMessage = document.getElementById("successMessage");
          if (successMessage) {
            successMessage.style.display = "block";
            successMessage.innerHTML =
              "<strong>Success!</strong> Your file is uploaded.";
          }
          // if (addToCartBtn) {
          //   addToCartBtn.disabled = false;
          //   addToCartBtn.style.opacity = "1";
          //   addToCartBtn.style.cursor = "";
          // }
        } else {
          pdfLinkContainer.innerHTML =
            "Upload successful, but no file ID found.";
        }
      } catch (err) {
        pdfLinkContainer.innerHTML = "Error: " + err.message;
        console.error(err);
      } finally {
        // Re-enable button & hide loader
        // saveBtn.disabled = false;
        // saveBtn.innerText = "Save & Upload";
        loader.style.display = "none";
      }
    }, 100);
  } catch (err) {
    alert("An error occurred: " + err.message);
    console.error(err);

    // Re-enable button & hide loader on failure
    saveBtn.disabled = false;
    saveBtn.innerText = "Save & Upload";
    loader.style.display = "none";
  }
});
// Automatic crop for images that haven't been edited
function processImageAutomatically(index) {
  return new Promise((resolve) => {
    const imgData = imagesData[index];
    const img = new Image();
    img.onload = function () {
      // 1.2" x 1.4" at 300 dpi => 360 x 420 pixels
      const canvas = document.createElement("canvas");
      const w = 1.2 * 300;
      const h = 1.4 * 300;
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");

      // White background
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, w, h);

      // Center the image in the 360x420 space
      const aspectRatio = img.width / img.height;
      let drawWidth, drawHeight;
      let offsetX = 0,
        offsetY = 0;

      if (aspectRatio > w / h) {
        drawHeight = h;
        drawWidth = drawHeight * aspectRatio;
        offsetX = (w - drawWidth) / 2;
      } else {
        drawWidth = w;
        drawHeight = drawWidth / aspectRatio;
        offsetY = (h - drawHeight) / 2;
      }

      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
      const croppedDataURL = canvas.toDataURL("image/jpeg", 1.0);

      imagesData[index].dataURL = croppedDataURL;
      imagesData[index].processed = true;
      updatePreviewImage(index, croppedDataURL);

      resolve();
    };
    img.onerror = function () {
      console.error("Failed to auto-process image #", index);
      resolve();
    };
    img.src = imgData.dataURL;
  });
}

// Generate PDF with 5x4 grid
async function generatePDF() {
  const { jsPDF } = window.jspdf;

  /* === constants (points) ===================================== */
  const DPI = 72; // pdf “points” per inch
  const CELL_W_IN = 1.2; // 1.2″  →  86.4 pt
  const CELL_H_IN = 1.4; // 1.4″  → 100.8 pt
  const GAP_IN = 1 / 6; // 0.1667″ gap (8 pt)
  const OUTER_MARGIN = 52; // 52 pt  (≈0.72″) on *all* sides

  /* === derived sizes ========================================== */
  const cellWidth = CELL_W_IN * DPI;
  const cellHeight = CELL_H_IN * DPI;
  const gap = GAP_IN * DPI;
  const cols = 5;
  const rows = 4;

  const pdfWidth = OUTER_MARGIN * 2 + cols * cellWidth + (cols - 1) * gap;

  const pdfHeight = OUTER_MARGIN * 2 + rows * cellHeight + (rows - 1) * gap;
  const doc = new jsPDF({
    unit: "pt",
    format: [pdfWidth, pdfHeight],
    orientation: "portrait",
    compress: false,
  });

  const imagesPerPage = cols * rows;
  const pageCount = Math.ceil(imagesData.length / imagesPerPage);

  for (let pageNum = 0; pageNum < pageCount; pageNum++) {
    if (pageNum > 0) {
      doc.addPage([pdfWidth, pdfHeight], "portrait");
    }

    for (let pos = 0; pos < imagesPerPage; pos++) {
      const imgIndex = pageNum * imagesPerPage + pos;
      if (imgIndex >= imagesData.length) break;

      const col = pos % cols;
      const row = Math.floor(pos / cols);
      const x = OUTER_MARGIN + col * (cellWidth  + gap) - 20; 
      const y = OUTER_MARGIN + row * (cellHeight + gap);   // ← unified margin

      // doc.setDrawColor(0);
      // doc.setLineWidth(1);
      doc.rect(x, y, cellWidth, cellHeight, "S");

      const imageData = await loadImageData(imagesData[imgIndex].dataURL);
      if (imageData) {
        doc.addImage(
          imageData.dataURL,
          "JPEG",
          x,
          y,
          cellWidth,
          cellHeight,
          `img${imgIndex}`,
          "FAST",
          0
        );
      } else {
        doc.setTextColor(100);
        doc.setFontSize(10);
        doc.text("No Image", x + cellWidth / 2, y + cellHeight / 2, {
          align: "center",
        });
      }
    }
  }

  doc.setProperties({
    title: "Image Grid for Production",
    creator: "Bulk Image Uploader",
    producer: "Bulk Image Uploader",
    resolution: 300,
  });

  return doc.output("blob");
}

// Helper to load dataURL into an <img> so we get width/height
function loadImageData(src) {
  return new Promise((resolve) => {
    if (!src) {
      resolve(null);
      return;
    }
    const img = new Image();
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
        dataURL: src,
      });
    };
    img.onerror = () => {
      console.error("Failed to load image src:", src);
      resolve(null);
    };
    img.src = src;
  });
}

// Close modals on clicking outside
window.onclick = function (event) {
  if (event.target === uploaderModal) {
    uploaderModal.style.display = "none";
  }
  if (event.target === cropModal) {
    cropModal.style.display = "none";
  }
};
